import { DocumentTextIcon } from "@heroicons/react/24/outline";

import classNames from "../../utils/classNames";

// TODO: replace with T&Cs pulled from admin settings once endpoint exists.
const DEFAULT_TERMS: string[] = [
  "All parts are sold as second-hand, used vehicle parts unless otherwise stated.",
  "Returns must be requested within 14 days and parts returned in their original condition.",
  "Fitting is the responsibility of the customer; consequential losses are not covered.",
  "Warranty (if purchased) covers the part itself and excludes labour unless explicitly included.",
  "Refunds are processed back to the original payment method once the returned part is inspected.",
];

interface BasketTermsAndConditionsProps {
  confirmed: boolean;
  onConfirmedChange: (next: boolean) => void;
  terms?: string[];
  disabled?: boolean;
}

export default function BasketTermsAndConditions({
  confirmed,
  onConfirmedChange,
  terms = DEFAULT_TERMS,
  disabled,
}: BasketTermsAndConditionsProps) {
  return (
    <div
      className={classNames(
        "rounded-md border p-4 transition-colors",
        confirmed ? "border-emerald-300 bg-emerald-50/40" : "border-gray-200"
      )}
    >
      <h3 className="flex items-center gap-2 text-sm font-semibold text-gray-800">
        <DocumentTextIcon
          className="h-4 w-4 text-primary-600"
          aria-hidden="true"
        />
        Terms &amp; Conditions
      </h3>
      <p className="mt-0.5 text-xs text-gray-500">
        Read each point to the customer before checkout.
      </p>

      <ul className="mt-3 max-h-48 list-disc space-y-1 overflow-y-auto rounded border border-gray-200 bg-white p-3 pl-6 text-xs text-gray-700">
        {terms.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>

      <label className="mt-3 flex items-start gap-2 text-sm text-gray-800">
        <input
          type="checkbox"
          checked={confirmed}
          disabled={disabled}
          onChange={(e) => onConfirmedChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
        />
        <span>
          I confirm the Terms &amp; Conditions above have been read to the
          customer.
          <span className="ml-1 text-rose-600" aria-hidden="true">
            *
          </span>
        </span>
      </label>
    </div>
  );
}
